const styles = (theme) => ({
  dialogContent: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(3),
  },
  courseSummary: {
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.grey[50] || '#F8F9FB',
    border: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(3),
  },
  sectionLabel: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  manualToggle: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  manualSection: {
    marginBottom: theme.spacing(3),
  },
  fieldStack: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  sectionDivider: {
    margin: theme.spacing(3, 0),
  },
  footerActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2),
  },
});

export default styles;
